import styled from "styled-components";
import { layout } from "styled-system";
import { Box } from "@bca/ui-library";

import { ViewportSizeType } from "../hooks/useViewport.hook";

interface StyledKeyDecisionInfoContainerProps {
  anchorLink?: string;
  viewport?: ViewportSizeType;
}

export const StyledKeyDecisionInfoContainer = styled(
  Box
)<StyledKeyDecisionInfoContainerProps>`
  box-sizing: border-box;
  display: flex;
  gap: 12px;
  flex-direction: column;
  align-items: flex-start;
  width: ${(props) => (props.viewport === "mobile" ? "100%" : "auto")};
  padding: 10px;
  border-radius: 8px;
  cursor: ${(props) => (props.anchorLink ? "pointer" : "initial")};
  z-index: 1;
  ${layout}
`;

const KeyDecisionInfoContainer = ({
  children,
  onClick = null,
  viewport = null,
  anchorLink = null,
}) => (
  <StyledKeyDecisionInfoContainer
    backgroundColor="secondary-light-grey"
    onClick={onClick}
    viewport={viewport}
    anchorLink={anchorLink}
  >
    {children}
  </StyledKeyDecisionInfoContainer>
);

export default KeyDecisionInfoContainer;
